// Fetch list

export const FETCH = 'reportDriverSurcharge.FETCH'
export const FETCH_STARTED = 'reportDriverSurcharge.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportDriverSurcharge.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportDriverSurcharge.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportDriverSurcharge.FETCH_CANCELLED'

// Driver note

export const DRIVER_NOTE_UPDATE = 'reportDriverSurcharge.DRIVER_NOTE_UPDATE'
export const DRIVER_NOTE_UPDATE_STARTED = 'reportDriverSurcharge.DRIVER_NOTE_UPDATE_STARTED'
export const DRIVER_NOTE_UPDATE_FULFILLED = 'reportDriverSurcharge.DRIVER_NOTE_UPDATE_FULFILLED'
export const DRIVER_NOTE_UPDATE_REJECTED = 'reportDriverSurcharge.DRIVER_NOTE_UPDATE_REJECTED'
export const DRIVER_NOTE_UPDATE_CANCELLED = 'reportDriverSurcharge.DRIVER_NOTE_UPDATE_CANCELLED'

// Clear

export const CLEAR = 'reportDriverSurcharge.CLEAR'

// Export

export const EXPORT = 'reportDriverSurcharge.EXPORT'
export const EXPORT_FULFILLED = 'reportDriverSurcharge.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportDriverSurcharge.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportDriverSurcharge.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportDriverSurcharge.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportDriverSurcharge.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportDriverSurcharge.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportDriverSurcharge.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportDriverSurcharge.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportDriverSurcharge.EXPORT_DETAILS_FULFILLED'
